
import { useNavigate } from 'react-router-dom';

export const useNavbarNavigation = () => {
  const navigate = useNavigate();

  const handleFAQClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/faq');
  };

  return { handleFAQClick };
};
